import { Map, Set } from 'immutable';

export default class BranchHierarchyTiers {

  constructor(hierarchyTerms) {
    this.hierarchyTerms = hierarchyTerms;
    this.numberOfBranchHierarchyTiers = this.hierarchyTerms ? this.hierarchyTerms.size : 0;
    this._nameForEmployees = Map({ singular: 'employee', plural: 'employees' });
  }

  tierIndexFromAnalyticsAggregationLevel = (analyticsAggregationLevel) => {
    if (analyticsAggregationLevel < 1 || analyticsAggregationLevel > this.numberOfBranchHierarchyTiers) {
      return null;
    }
    return this.numberOfBranchHierarchyTiers - analyticsAggregationLevel;
  };

  tierNameFromAnalyticsAggregationLevel = (
    analyticsAggregationLevel,
    nameForEmployees = this._nameForEmployees
  ) => {
    const tierNumber = this.tierIndexFromAnalyticsAggregationLevel(analyticsAggregationLevel);
    if (Number.isInteger(tierNumber)) {
      return this.hierarchyTerms.get(tierNumber);
    }
    return nameForEmployees;
  };

  analyticsAggregationLevelFromTierIndex = (tierIndex) => {
    if (tierIndex < 0 || tierIndex > (this.numberOfBranchHierarchyTiers - 1)) {
      return null;
    }
    return this.numberOfBranchHierarchyTiers - tierIndex;
  };

  tierIndexFromTierName = (tierName) => {
    return this.hierarchyTerms.findIndex((termMap) =>
      termMap.get('singular').toLowerCase() === tierName ||
      termMap.get('plural').toLowerCase() === tierName
    );
  };

  analyticsAggregationLevelFromTierName = (tierName) => {
    const tierIndex = this.tierIndexFromTierName(tierName);
    const aggLevel = this.analyticsAggregationLevelFromTierIndex(tierIndex);
    const isEmployeeTier =
      (this._nameForEmployees.get('singular').toLowerCase() === tierName ||
        this._nameForEmployees.get('plural').toLowerCase() === tierName);
    if (aggLevel === null && isEmployeeTier) {
      return 0;
    }
    return aggLevel;
  };

  createFilter = (elemIds, tierIndex) => {
    return !this.hierarchyTerms ? null : this.hierarchyTerms.map((tier, i) => {
      if (i === tierIndex) {
        return elemIds.map((elemId) => Map({id: elemId})).toSet();
      }
      return Set();
    });
  };

}



// WEBPACK FOOTER //
// ./src/model/BranchHierarchyTiers.js